// src/services/firebase.js
import { initializeApp, getApp, getApps } from "firebase/app";
import { getMessaging, getToken, isSupported, onMessage } from "firebase/messaging";

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

let messagingInstance = null;
let supportChecked = false;

/** Đảm bảo chỉ khởi tạo messaging khi chạy trên browser & có hỗ trợ */
export const ensureMessaging = async () => {
  if (supportChecked && messagingInstance) return messagingInstance;

  if (typeof window === "undefined") return null;
  try {
    const supported = await isSupported();
    supportChecked = true;
    if (!supported) return null;
    messagingInstance = getMessaging(app);
    return messagingInstance;
  } catch {
    return null;
  }
};

/** Đăng ký SW (nếu chưa), trả về registration */
export const registerFcmServiceWorker = async () => {
  if (!("serviceWorker" in navigator)) return null;
  // Gộp firebaseConfig -> query string an toàn
  const params = new URLSearchParams(firebaseConfig).toString();
  const swUrl = `/firebase-messaging-sw.js?${params}`; // SW ở public root

  // Nếu đã ready, cứ dùng. Nếu chưa, register.
  const existing = await navigator.serviceWorker.getRegistration();
  if (existing && existing.active && existing.active.scriptURL.includes("firebase-messaging-sw.js")) {
    return existing;
  }

  try {
    const reg = await navigator.serviceWorker.register(swUrl, { scope: "/" });
    await navigator.serviceWorker.ready; // đảm bảo active
    return reg;
  } catch (err) {
    console.error("[FCM] SW register failed:", err);
    return null;
  }
};

export const getMessagingToken = async () => {
  const messaging = await ensureMessaging();
  if (!messaging) return "";

  try {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.log("Bạn cần cấp quyền thông báo.");
      return "";
    }

    const swReg = await registerFcmServiceWorker();
    if (!swReg) return "";

    const currentToken = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_FIREBASE_PUBLIC_VAPID_KEY,
      serviceWorkerRegistration: swReg,
    });

    if (currentToken) {
      console.log("FCM registration token:", currentToken);
      return currentToken;
    }
  } catch (error) {
    console.log("Lỗi lấy token FCM:", error);
  }
  return "";
};

/** Lắng nghe message khi tab đang mở (foreground) */
export const onForegroundMessage = async (cb) => {
  const messaging = await ensureMessaging();
  if (!messaging) return () => {};
  const unsubscribe = onMessage(messaging, (payload) => cb?.(payload));
  return unsubscribe;
};
